// /var/www/afra/web-design.rampagesoft.com/my-app/src/component/slidebar.js
import React, { useState, useEffect } from 'react';
import { Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/scrollbar';
import '../css/SlidebarContent.scss';

const Sidebar = ({
  data,
  heading,
  theme = 'primary-default',
  onSwiper = () => {},
  onSlideChange = () => {}
}) => {
  const [images, setImages] = useState({});
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    async function loadImages() {
      const results = await Promise.all(
        data.map(async service => {
          if (service.img.startsWith('https')) {
            return { id: service.id, imgUrl: service.img };
          }
          const imgModule = await import(`../media/success/${service.img}`);
          return { id: service.id, imgUrl: imgModule.default };
        })
      );
      setImages(Object.fromEntries(results.map(r => [r.id, r.imgUrl])));
    }

    loadImages();

    const updateSlidesPerView = () => {
      const w = window.innerWidth;
      setSlidesPerView(w < 768 ? 1 : w < 1024 ? 2 : 3);
    };

    window.addEventListener('resize', updateSlidesPerView);
    updateSlidesPerView();
    return () => window.removeEventListener('resize', updateSlidesPerView);
  }, [data]);

  // Minimum slides needed for loop mode: slidesPerView + 2
  const minSlidesForLoop = slidesPerView + 2;
  const swiperConfig = {
    modules: [Scrollbar, A11y],
    spaceBetween: 50,
    slidesPerView: slidesPerView,
    slidesPerGroup: 1, // Explicitly set to 1
    loop: data.length >= minSlidesForLoop, // Disable loop if insufficient slides
    scrollbar: { draggable: true },
    onSwiper,
    onSlideChange
  };

  // console.log(
  //   `[Sidebar] Rendering Swiper: ${data.length} slides, slidesPerView: ${slidesPerView}, loop: ${swiperConfig.loop}`
  // );

  return (
    <section className={`SlidebarContent pad-tb-150 ${theme}`}>
      <div className="container box-border-su">
        <h3 className="headsuccess pad-b-30">{heading}</h3>
        <Swiper {...swiperConfig}>
          {data.map(service => (
            <SwiperSlide key={service.id}>
              <div>
                <a href={service.link}>
                  <img
                    className="img-su-pad"
                    src={images[service.id]}
                    alt={service.title}
                    loading="lazy"
                  />
                </a>
                <div className="box-su-pad">
                  <div className="latest-gallery__item-content-left">
                    <a href={service.link}>
                      <h4 className="head-box-text">{service.title}</h4>
                    </a>
                    <p className="head-box-p">{service.description}</p>
                  </div>
                  <a href={service.link} className="rs-btn button-deatil-p">
                    {service.namelink}
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Sidebar;